import { defineStyleConfig } from "@chakra-ui/styled-system";

export const DrawerStyles = defineStyleConfig({
    sizes :{
        xs: {
            width:'auto'
        }
    }
})